/*
 * Copyright (c) Volvo Group. All rights reserved.
 * SPDX-License-Identifier: ISC
 */

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

// Create the client with global error handling
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: 0,
    },
    mutations: {
      // Global error handler for mutations
      onError: (error) => {
        console.info(error);
      },
    },
  },
});

type ReactQueryProviderProps = {
  children: ReactNode;
};

/**
 * React Query provider component to wrap the application
 */
export const ReactQueryProvider = ({ children }: ReactQueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
